import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/events", label: "Events" },
    { to: "/gallery", label: "Gallery" },
    { to: "/contact", label: "Contact" },
  ];

  const isHome = location.pathname === "/";
  const isLight = !isHome && scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-8 lg:px-12 h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 group">
          <img
            src="https://static.readdy.ai/image/cb5bba3f8fb0d3000da0c3fb91699bfa/a250bf31368e0cf0c4367263661697d1.jpeg"
            alt="ACS Student Chapter Logo"
            className="h-10 w-10 rounded-full object-cover"
          />
          <div className="hidden sm:block">
            <span
              className={`font-heading font-bold text-lg leading-tight transition-colors ${
                scrolled || !isHome ? "text-primary-900" : "text-white"
              }`}
            >
              ACS Student Chapter
            </span>
            <p
              className={`text-xs transition-colors ${
                scrolled || !isHome ? "text-gray-500" : "text-white/80"
              }`}
            >
              Rivers State University
            </p>
          </div>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`relative text-sm font-medium transition-colors py-2 whitespace-nowrap ${
                scrolled || !isHome
                  ? "text-gray-700 hover:text-primary-900"
                  : "text-white/90 hover:text-white"
              } ${location.pathname === link.to ? "font-semibold" : ""}`}
            >
              {link.label}
              {location.pathname === link.to && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-gold-500 rounded-full" />
              )}
            </Link>
          ))}
        </div>

        {/* Hamburger */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
            scrolled || !isHome
              ? "text-gray-700 hover:bg-gray-100"
              : "text-white hover:bg-white/10"
          }`}
          aria-label="Toggle menu"
        >
          <i
            className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`}
          />
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.to
                    ? "bg-primary-50 text-primary-900"
                    : "text-gray-700 hover:bg-gray-50"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}